import React from 'react'
import { connect } from 'react-redux'
import history from '../../core/history'
import AdministrationLogin from './AdministrationLogin'
import { login, setEmailAddress, setPassword } from './administrationLoginContainerActions'
import PropTypes from 'prop-types';

class AdministrationLoginContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]),
    isInvalid: PropTypes.object,
    message: PropTypes.string,
    emailAddress: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    submitting: PropTypes.bool.isRequired,
    loginFailed: PropTypes.bool.isRequired,
    loginSucceeded: PropTypes.bool.isRequired,
    login: PropTypes.func.isRequired,
    setEmailAddress: PropTypes.func.isRequired,
    setPassword: PropTypes.func.isRequired
  }

  componentDidUpdate () {
    if (this.props.loginSucceeded) history.push('/administration/pendingapprovalAdviserProfiles')
  }

  resetPassword (event) {
    // Stop the empty href from also doing a full-page reload on top of the client-side push
    // (that redundant reload is the error-page flash seen on the way to the reset screen).
    if (event) event.preventDefault()
    history.push('/administration/reset-password')
  }

  render () {
    return (
      <AdministrationLogin
        isInvalid={this.props.isInvalid}
        emailAddress={this.props.emailAddress}
        password={this.props.password}
        submitting={this.props.submitting}
        loginFailed={this.props.loginFailed}
        login={() => this.props.dispatch(this.props.login(this.props.emailAddress, this.props.password))}
        emailAddressChange={(emailAddress) => this.props.dispatch(this.props.setEmailAddress(emailAddress))}
        passwordChange={(password) => this.props.dispatch(this.props.setPassword(password))}
        resetPassword={this.resetPassword} />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    submitting: state.administrationLoginContainer.submitting,
    isInvalid: state.administrationLoginContainer.isInvalid,
    emailAddress: state.administrationLoginContainer.emailAddress,
    password: state.administrationLoginContainer.password,
    loginFailed: state.administrationLoginContainer.loginFailed,
    loginSucceeded: state.administrationLoginContainer.loginSucceeded
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: login,
    setEmailAddress: setEmailAddress,
    setPassword: setPassword,
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationLoginContainer)
